import { Helmet } from 'react-helmet-async';

export default function GuaranteePage() {
  const guarantees = [
    { title: '100% Authentic Tickets', desc: 'Every ticket is verified authentic before delivery.' },
    { title: 'On-Time Delivery', desc: 'Your tickets will arrive before the event.' },
    { title: 'Full Refund Protection', desc: 'If there is an issue, you will receive a full refund.' },
    { title: 'Replacement Guarantee', desc: 'If delivery fails, we find you comparable or better tickets.' }
  ];

  return (
    <>
      <Helmet><title>Buyer Guarantee | BESTIX</title></Helmet>
      <div className="min-h-screen bg-gray-50">
        <div className="bg-navy py-16">
          <div className="container mx-auto px-4 text-center">
            <h1 className="font-playfair text-4xl font-bold !text-white">Buyer Guarantee</h1>
            <p className="mt-4 text-xl text-gray-300">Your purchase is protected</p>
          </div>
        </div>
        <div className="container mx-auto px-4 py-16">
          <div className="max-w-3xl mx-auto space-y-8">
            {guarantees.map((g, i) => (
              <div key={i} className="bg-white p-6 rounded-xl shadow-md">
                <h3 className="font-semibold text-navy text-lg mb-2">{g.title}</h3>
                <p className="text-gray-600">{g.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
